import {useMutation} from "@tanstack/react-query";
import {downloadFile} from "../../../../util/FileDownload";
import {downloadCompanyInfoReg} from "../../../../api/manage/company/CompanyApi";

export const useDownloadCompanyReg = () => {
    const {mutate} = useMutation({
        mutationFn: (data: {
            fileKey: string;
            fileOrgname: string;
            fileUrl: string;
        }) => downloadCompanyInfoReg(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                downloadFile(res, variables.fileOrgname)
            }
        },
    });

    return {mutate};
};
